module.exports = __webpack_public_path__ + "static/media/display1.90b36eac.svg";